export default {
  title_one: 'Slet {{count}} modifikatorer?',
  title_other: 'Slet {{count}} modifikatorer?',
  description: '<strong>{{items}}</strong> fjernes fra menuen',
  buttons: {
    yes: 'Ja',
    no: 'Nej',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Modifikatoren kunne ikke slettes',
    failed_to_delete_modifier_other: 'Modifikatorerne kunne ikke slettes',
    modifiers_got_deleted_one: 'Modifikatoren er slettet',
    modifiers_got_deleted_other: 'Modifikatorerne er slettet',
  },
};
